import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { KidsFlasherProvider } from './context/KidsFlasherContext';

import HomePage from './pages/HomePage';
import LoadingPage from './pages/LoadingPage';
import ResultsPage from './pages/ResultsPage';
import NotFoundPage from './components/NotFoundPage';

import './styles/globals.css';

const App = () => {
  return (
    <KidsFlasherProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/loading" element={<LoadingPage />} />
          <Route path="/loading/preview" element={<LoadingPage isPreview={true} />} />
          <Route path="/results/:riotId" element={<ResultsPage />} />
          <Route path="/shared/:shareId" element={<ResultsPage isShared={true} />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </KidsFlasherProvider>
  );
};

export default App;